module.exports = __webpack_public_path__ + "media/promo/advent/images/garland-2-1-6fd98d0ecf0017c7bc6479b4c5014ee1.png";